import { render, staticRenderFns } from "./BNC10000.vue?vue&type=template&id=d7153036&"
import script from "./BNC10000.vue?vue&type=script&lang=js&"
export * from "./BNC10000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports